<template>
  <app-layout>
    <template v-slot:headerTitle>
      {{ configs.heading }}
    </template>
    <template v-slot:headerNav>
      <nav-items></nav-items>
    </template>

    <template v-slot:tcmainnav> </template>

    <div class="back pt-14">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div>
          <div>
            <div class="row">
              <div class="col">
                <jet-button
                  class="
                    bg-blue-500
                    rounded
                    text-white
                    hover:bg-blue-500 hover:no-underline
                    px-2
                    cursor-pointer
                    text-sm
                  "
                  @click="goToRoute(value)"
                  v-for="(value, key) in configs.actions"
                  >{{ key }}</jet-button
                >

                <!-- <jet-button class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" @click="goToCreateVoucher"> Add Voucher</jet-button> 
                    <jet-button class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" @click="goToCreateLedger"> Add Ledger</jet-button>
                    <jet-button class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" @click="goToCreateStockitem"> Add StockItem</jet-button> -->
              </div>
            </div>
            <div class="mt-2">
              <div
                class="
                  bg-white
                  overflow-hidden
                  shadow-xl
                  px-2
                  py-2
                  sm:rounded-lg
                "
              >
                <BsIndex
                  :slug="slug"
                  :routeDef="this.moduleRoute"
                  :headersDef="headers"
                >
                </BsIndex>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>
<script>
import navItems from "@include/pages/modules/Components/nav_items";
// import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import AppLayout from "@/Layouts/AppLayout.vue";
import BsIndex from "@/Base/BsIndex.vue";
//import { DxDataGrid } from 'devextreme-vue/data-grid';
import DataSource from "devextreme/data/data_source";
import "devextreme/data/odata/store";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
let collapsed = false;
export default {
  props: {
    moduleRoute: String,
    headers: Array,
    moduleName: String,
    configs: Array,
    id: String,
    slug: String,
  },
  components: {
    AppLayout,
    BsIndex,
    PageTitle,
    JetNavLink,
    JetButton,
    navItems,
  },
  data() {
    return {
      title: this.moduleName,
      dataSource: new DataSource({
        store: {
          type: "odata",
          url: "https://js.devexpress.com/Demos/SalesViewer/odata/DaySaleDtoes",
          key: "Id",
          beforeSend: function (request) {
            request.params.startDate = "2020-05-10";
            request.params.endDate = "2020-05-15";
          },
        },
      }),
      grouping: {
        contextMenuEnabled: true,
        autoExpandAll: false,
        expandMode: "rowClick",
      },
      groupPanel: {
        visible: true,
      },
      columns: ["Product", "Region", "SaleDate", "Channel", "Customer"],
      pageSizes: [10, 25, 50, 100],
      onContentReady: function (e) {
        if (!collapsed) {
          e.component.expandRow(["EnviroCare"]);
          collapsed = true;
        }
      },
    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreateVoucher() {
      this.$inertia.get(route("add_voucher"));
    },
    goToCreateLedger() {
      this.$inertia.get(route("add_ledger"));
    },
    goToCreateStockitem() {
      this.$inertia.get(route("add_stock_item"));
    },
    goToRoute(value) {
      this.$inertia.get(route(value));
    },
    showRoute() {
      this.$inertia.get("/tdlbuildermods/" + this.id + "");
    },
  },
  data: function () {
    return {
      title: this.moduleRoute + " List",
    };
  },
  mounted() {
    // console.log("moduleRoute");
    //  console.log(this.moduleRoute);
    //console.log("Examples component mounted");
  },
};
</script>
<style >
.back {
  background-color: #f3f4f6;
  height: 92vh !important;
  /* line-height:517px; */
}
.main-content {
  background-color: #f3f4f6;
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  margin-left: 212px;
  padding-bottom: 10px;
}
</style>
